import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Modal from '../Modal/Modal';
import { OWNER_DOCUMENT_TYPES, toOfficialDocType } from '../../utils/constants';
import './OfficialRecordsConfirmModal.css';

const OfficialRecordsConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    initialValues = {},
    initialConsultBy = 'document',
}) => {
    const [consultBy, setConsultBy] = useState('document');
    const [placa, setPlaca] = useState('');
    const [docType, setDocType] = useState('');
    const [docNumber, setDocNumber] = useState('');
    const [vin, setVin] = useState('');

    useEffect(() => {
        if (isOpen) {
            setConsultBy(initialConsultBy === 'vin' ? 'vin' : 'document');
            setPlaca((initialValues.placa || '').toUpperCase());
            setDocType(toOfficialDocType(initialValues.docType));
            setDocNumber(initialValues.docNumber || '');
            setVin((initialValues.vin || '').toUpperCase());
        }
    }, [
        isOpen,
        initialConsultBy,
        initialValues.placa,
        initialValues.docType,
        initialValues.docNumber,
        initialValues.vin,
    ]);

    if (!isOpen) return null;

    const canConfirm = consultBy === 'vin'
        ? Boolean(vin.trim())
        : Boolean(placa.trim() && docType.trim() && docNumber.trim());

    const handleConfirm = () => {
        if (consultBy === 'vin') {
            onConfirm({
                consultBy: 'vin',
                vin: vin.trim().toUpperCase(),
            });
            return;
        }
        onConfirm({
            consultBy: 'document',
            placa: placa.trim(),
            docType: docType.trim(),
            docNumber: docNumber.trim(),
        });
    };

    return createPortal(
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="medium"
            showCloseButton={true}
            closeOnBackdropClick={false}
            overlayZIndex={1100}
            manageBodyScroll={false}
        >
            <div className="official-records-modal">
                <h3 className="official-records-modal-title">Confirmar consulta de antecedentes</h3>
                <div className="official-records-switch" role="tablist" aria-label="Tipo de consulta">
                    <button
                        type="button"
                        role="tab"
                        aria-selected={consultBy === 'document'}
                        className={`official-records-switch-option ${consultBy === 'document' ? 'active' : ''}`}
                        onClick={() => setConsultBy('document')}
                    >
                        Por documento
                    </button>
                    <button
                        type="button"
                        role="tab"
                        aria-selected={consultBy === 'vin'}
                        className={`official-records-switch-option ${consultBy === 'vin' ? 'active' : ''}`}
                        onClick={() => setConsultBy('vin')}
                    >
                        Por VIN
                    </button>
                </div>
                <p className="official-records-modal-copy">
                    {consultBy === 'vin'
                        ? 'Revisa y corrige si hace falta el VIN que se enviará a consultar.'
                        : 'Revisa y corrige si hace falta la placa y los datos del propietario que se enviarán a consultar.'}
                </p>
                <div className="official-records-modal-fields">
                    {consultBy === 'vin' ? (
                        <label htmlFor="official-vin">
                            VIN
                            <input
                                id="official-vin"
                                type="text"
                                value={vin}
                                onChange={(e) => setVin(e.target.value.toUpperCase())}
                            />
                        </label>
                    ) : (
                        <>
                            <label htmlFor="official-placa">
                                Placa
                                <input
                                    id="official-placa"
                                    type="text"
                                    value={placa}
                                    onChange={(e) => setPlaca(e.target.value.toUpperCase())}
                                />
                            </label>
                            <label htmlFor="official-docType">
                                Tipo de documento
                                <select
                                    id="official-docType"
                                    value={docType}
                                    onChange={(e) => setDocType(e.target.value)}
                                >
                                    <option value="">Selecciona una opción</option>
                                    {OWNER_DOCUMENT_TYPES.map((type) => (
                                        <option key={type.value} value={type.value}>
                                            {type.label}
                                        </option>
                                    ))}
                                </select>
                            </label>
                            <label htmlFor="official-docNumber">
                                Número de documento
                                <input
                                    id="official-docNumber"
                                    type="text"
                                    value={docNumber}
                                    onChange={(e) => setDocNumber(e.target.value)}
                                />
                            </label>
                        </>
                    )}
                </div>
                <div className="official-records-modal-actions">
                    <button
                        type="button"
                        className="official-records-btn official-records-btn-cancel"
                        onClick={onClose}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="official-records-btn official-records-btn-confirm"
                        disabled={!canConfirm}
                        onClick={handleConfirm}
                    >
                        Confirmar consulta
                    </button>
                </div>
            </div>
        </Modal>,
        document.body
    );
};

export default OfficialRecordsConfirmModal;
